var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_505_407",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_505_407",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAAAXNSR0IArs4c6QAAAdJJREFUeAHtncFKgzEAxnxCp6LsoM8uDBFFH0EhUi8D6bw20Ow0vDRN+LbTP6+uemUgAxnIQAYykIEMZCADGcjAUgPALfAGfAL3S2F2Pxw4Al+cXx+7O1l2/0mMkeV9GdDOB1+IMZZyt7OXJXcHHv58TI1lfAOPS4B2PrQYovrFKIbIgAilZRRDZECE0jKKITIgQmkZxRAZEKG0jGKIDIhQWkYxRAZEKC2jGCIDIpSWUQyRARFKyyiGyIAIpWUUQ2RAhNIyiiEyIEJpGcUQGRChtIxiiAyIUFpGMUQGRCgtoxgiAyKUllEMkQERSssohsiACAW4mTzTNx6wPIow90EBXs6Pgf++K8bK/AVZaX9ydh9ZEymr/zR+Q2TyPTKeDX9azbbt+UURpi9KUYQGhEgtpShCA0KkllIUoQEhUkspitCAEKmlFEVoQIjUUooiNCBEailFERoQIrWUoggNCJFaSlGEBoRILaUoQgNCpJZSFKEBIVJLKYrQgBCppRRFaECI1FKKIjQgRGopRREaECK1lKIIDQiRWkpRhAaESP/8c+KDEHcPpAtRTnvcXnrLSZRXKeo+WMABeAZOwPU+N++mGchABjKQgQxkIAMZyMCuBn4An8GCVUa3RE4AAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoback);
export default __webpack_public_path__ + "static/media/goback.faddfe8dfea0c410a2dd29ac98e5f79c.svg";
export { ForwardRef as ReactComponent };